import {
  Box,
  Text,
  Input,
  Button,
  Flex,
  useDisclosure,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalBody,
  ModalCloseButton,
  ModalFooter,
  IconButton,
  Divider,
  SimpleGrid,
  Badge,
} from '@chakra-ui/react';
import TableContainer from 'components/common/TableContainer';
import { useEffect, useMemo, useState } from 'react';
import httpInjectorService from 'services/http-injector.service';
import { MdFilterListAlt, MdDownload } from 'react-icons/md';
import { ViewIcon } from '@chakra-ui/icons';
import { BulletList } from 'react-content-loader';
import { Empty } from 'antd';
import * as XLSX from 'xlsx';
import { ChangedFields } from './ProfileAuditCol';
import { toast } from 'react-toastify';
import { demoCompanyAuditLogs } from 'components/demodata/Dummydata';

// const CompanyAudit = () => {
const isImageField = (field) => field === 'logo_url';

const capitalizeWords = (str) => {
  if (!str || typeof str !== 'string') return str;
  return str
    .split(' ')
    .map(w => w ? w.charAt(0).toUpperCase() + w.slice(1) : '')
    .join(' ');
};
const renderValue = (data, field) => {
  const value = data?.[field];
  //added for names in reporting manager fields
  if (field === 'reporting_manager_id1') {
  return data?.reporting_manager_name1 || value;
}

if (field === 'reporting_manager_id2') {
  return data?.reporting_manager_name2 || value;
}

  if (field === 'department_head') {
    return data?.username || value;
  }
  // REPORTING MANAGER REMOVED
  if (
    (field === 'reporting_manager_id1' || field === 'reporting_manager_id2') &&
    value === null
  ) {
    return;
  }

  if (value === null || value === undefined) return 'null';

  // LOGO
  if (isImageField(field)) {
    return value ? (
      <img
        src={value}
        alt="logo"
        style={{
          width: '60px',
          height: '60px',
          objectFit: 'contain',
          borderRadius: '8px',
          border: '1px solid #ddd',
        }}
      />
    ) : (
      'null'
    );
  }
  if (field === 'subDepartments') {
  if (!Array.isArray(value)) return 'null';

  return value
    .map(v => capitalizeWords(v.subDepartment || v.subdepartment))
    .filter(Boolean)
    .join(', ');
}

  if (Array.isArray(value)) {
    return value
      .map((v) => (typeof v === 'object' ? JSON.stringify(v) : v))
      .join(', ');
  }

  if (typeof value === 'object') {
    return JSON.stringify(value);
  }

  if (typeof value === 'string') {
    return capitalizeWords(value);
  }
  return value;
};

const CompanyAudit = ({ isActive }) => {
  const [companyAuditLogs, setCompanyAuditLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const { isOpen, onOpen, onClose } = useDisclosure();
  const [selectedLog, setSelectedLog] = useState(null);

  const renderDiffUI = (log) => {
    
    const getFieldLabel = (field) => {
      const labelMap ={
        reporting_manager_id1: 'Reporting Manager 1',
        reporting_manager_id2: 'Reporting Manager 2',
        department_head: 'Department Head',
        department_name: 'Department Name',
      };
      return labelMap[field] || field.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
    };

    const fields = (log.changed_fields || []).filter(
      (field) => !['org_id', 'user_id','reporting_manager_name1','reporting_manager_name2'].includes(field),
    );

    const specialFields = [
      'designation',
      'name',
      'department',
      'subdepartment',
      'subDepartments',
    ];

    // Separate fields
    const groupedFields = fields.filter((field) =>
  specialFields.includes(field) && field !== 'subDepartments'
    );

    const normalFields = fields.filter(
      (field) => !specialFields.includes(field) && field !== 'username'
    );

return (
  <>
    {/* SPECIAL FIELDS → SINGLE BOX */}
    {groupedFields.length > 0 && (
      <Box p={5} borderRadius="xl" bg="white" border="1px solid" borderColor="gray.200" boxShadow="md" mb={4}>
        <Flex direction="column" gap={6}>
          {groupedFields.map((field, index) => (
            <Box key={index}>
              <Text fontSize="sm" fontWeight="semibold" color="purple.600" textTransform="capitalize" mb={1}>
                {getFieldLabel(field)}
                {/* {field.replace(/_/g, ' ')} */}
              </Text>
              <Text fontSize="sm" color="gray.700">
                {renderValue(log.new_data, field) || '—'}
              </Text>
            </Box>
          ))}
        </Flex>
      </Box>
    )}

    {/*  ADD HERE — RIGHT AFTER groupedFields box, BEFORE normalFields grid */}
  {fields.includes('subDepartments') && (
  <Box p={5} borderRadius="xl" bg="white" border="1px solid" borderColor="gray.200" boxShadow="md" mb={4}>
    <Flex direction="column" gap={4}>
      {(() => {
        const subDepts = log.new_data?.subDepartments;
        const oldSubDepts = log.new_data?.oldSubDepartments || [];
        const departmentName =
          Array.isArray(subDepts) && subDepts.length > 0
            ? subDepts[0]?.department
            : null;

        return (
          <>
            {departmentName && (
              <Box>
                <Text fontSize="sm" fontWeight="semibold" color="purple.600" mb={1}>
                  Department
                </Text>
                <Text fontSize="sm" color="gray.700">
                  {capitalizeWords(departmentName)}</Text>
              </Box>
            )}
            <Box>
              <Text fontSize="sm" fontWeight="semibold" color="purple.600" mb={1}>
                Sub Departments
              </Text>

              {Array.isArray(subDepts) && subDepts.map((v, i) => {
                const oldMatch = oldSubDepts.find(
                  o => o.subDepartmentId === v.subDepartmentId
                );

                // ✅ Modified subdept → show OLD / NEW
                if (oldMatch) {
                  return (
                    <Flex key={i} gap={2} mt={2} direction={{ base: 'column', md: 'row' }}>
                      <Box flex={1} bg="red.50" p={2} borderRadius="md" border="1px solid" borderColor="red.100">
                        <Text fontSize="xs" color="red.500">OLD</Text>
                        <Text fontSize="sm">{capitalizeWords(oldMatch.subDepartment) || '—'}</Text>
                      </Box>
                      <Box flex={1} bg="green.50" p={2} borderRadius="md" border="1px solid" borderColor="green.100">
                        <Text fontSize="xs" color="green.500">NEW</Text>
                        <Text fontSize="sm">{capitalizeWords(v.subDepartment) || '—'}</Text>
                      </Box>
                    </Flex>
                  );
                }

                // Newly added subdept → just show name
                return (
                  <Text key={i} fontSize="sm" color="gray.700" mt={1}>
                    {capitalizeWords(v.subDepartment || v.subdepartment)}
                  </Text>
                );
              })}
            </Box>
          </>
        );
      })()}
    </Flex>
  </Box>
)}


     {(fields.includes('reporting_manager_id1') || fields.includes('reporting_manager_id2')) &&
          log.new_data?.username && (
            <Box p={5} borderRadius="xl" bg="white" border="1px solid" borderColor="gray.200" boxShadow="md" mb={4}>
              <Text fontSize="sm" fontWeight="semibold" color="purple.600" mb={1}>
                Reporting Manager Assigned To
              </Text>
              <Text fontSize="sm" color="gray.700">
                {capitalizeWords(log.new_data.username)}
              </Text>
            </Box>
          )
        }
 {fields.includes('department_head') && log.new_data?.department_name && (
            <Box p={4} borderRadius="xl" bg="white" border="1px solid" borderColor="gray.200" boxShadow="md" mb={4}>
              <Text fontSize="sm" fontWeight="semibold" color="purple.600" mb={1}>
                Department
              </Text>
              <Text fontSize="sm" color="gray.700">
                {capitalizeWords(log.new_data.department_name)}
              </Text>
            </Box>
          )
        }
        {/*  NORMAL FIELDS → KEEP OLD / NEW UI SAME */}
        <SimpleGrid columns={{ base: 1, md: 2 }} spacing={4}>
          {normalFields.map((field, index) => (
            <Box
              key={index}
              p={5}
              borderRadius="xl"
              bg="white"
              border="1px solid"
              borderColor="gray.200"
              boxShadow="md"
              transition="0.2s"
              _hover={{
                boxShadow: 'lg',
                transform: 'translateY(-2px)',
              }}
            >
              {/* FIELD NAME */}
              <Text
                fontWeight="semibold"
                fontSize="sm"
                color="purple.600"
                mb={4}
                textTransform="capitalize"
              >
                {/* {field.replace(/_/g, ' ')} */}
                {getFieldLabel(field)} 
              </Text>

              {/* OLD / NEW UI */}
              <Flex gap={2} direction={{ base: 'column', md: 'row' }}>
                {/* OLD */}
                <Box
                  flex={1}
                  bg="red.50"
                  p={2}
                  borderRadius="md"
                  border="1px solid"
                  borderColor="red.100"
                >
                  <Text fontSize="xs" color="red.500">
                    OLD
                  </Text>

                  <Text fontSize="sm">
                    {renderValue(log.old_data, field) || '—'}
                  </Text>
                </Box>

                {/* NEW */}
                <Box
                  flex={1}
                  bg="green.50"
                  p={2}
                  borderRadius="md"
                  border="1px solid"
                  borderColor="green.100"
                >
                  <Text fontSize="xs" color="green.500">
                    NEW
                  </Text>

                  <Text fontSize="sm">
                    {renderValue(log.new_data, field) || '—'}
                  </Text>
                </Box>
              </Flex>
            </Box>
          ))}
        </SimpleGrid>
      </>
    );
  };

  const renderInsertUI = (log) => {
    const data = log.new_data || {};

  // Fields in required order
  const fieldOrder = ['department_name', 'department_head', 'subDepartments'];

  // Fields to always hide
  const hiddenFields = ['org_id', 'user_id', 'username',  'reporting_manager_name1', 'reporting_manager_name2',];

  // Decide whether field should be shown
  const shouldShowField = (key, value) => {
    if (hiddenFields.includes(key)) return false;

    // always show core fields if they exist
    if (key === 'department_name' || key === 'subDepartments') {
      return value !== null && value !== undefined;
    }

    // show department_head only if actually provided
    if (key === 'department_head') {
      return value !== null && value !== undefined && value !== '';
    }

    // fallback
    return value !== null && value !== undefined;
  };

  // Ordered fields first + remaining fields later
  const orderedEntries = [
    ...fieldOrder
      .filter((key) => shouldShowField(key, data[key]))
      .map((key) => [key, data[key]]),

    ...Object.entries(data).filter(
      ([key, value]) =>
        !fieldOrder.includes(key) &&
        shouldShowField(key, value)
    ),
  ];

    return (
      <Box
        p={6}
        borderRadius="xl"
        border="1px solid"
        borderColor="green.200"
        bg="white"
        boxShadow="md"
      >
        <Box display="flex" flexDirection="column" gap={4}>
          {/* {Object.entries(data).map(([key, value], index) => ( */}
          {orderedEntries.map(([key, value], index) => (
            <Box key={index}>
              <Text fontSize="sm" fontWeight="semibold" color="purple.600">
                {key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
              </Text>
              <Text fontSize="sm" color="gray.700">
                {capitalizeWords(renderValue(data, key))}
              </Text>
            </Box>
          ))}
        </Box>
      </Box>
    );
  };

  const renderDeleteUI = (log) => {
    const data = log.old_data || {};
    const departmentName =
  data?.subDepartments?.[0]?.department || '';
    const fieldOrder = ['department_name', 'department_head', 'subDepartments'];

const orderedEntries = [
  ...Object.entries(data).filter(([key]) => key === 'username'),

  // 2. DEPARTMENT FIELDS (from fieldOrder)
  ...fieldOrder
    .filter((key) => key in data)
    .map((key) => [key, data[key]]),

  // 3. REPORTING MANAGER (only deleted ones)
  ...Object.entries(data).filter(([key]) =>
    ['reporting_manager_id1', 'reporting_manager_id2'].includes(key) &&
    (log.changed_fields || []).includes(key)
  ),

  // 4. EVERYTHING ELSE THAT WAS CHANGED (IMPORTANT FIX)
  ...Object.entries(data).filter(([key]) =>
    !['username', ...fieldOrder, 'reporting_manager_id1', 'reporting_manager_id2'].includes(key)
    && (log.changed_fields || []).includes(key)
  )
];

    return (
      <Box
        p={6}
        borderRadius="xl"
        border="1px solid"
        borderColor="gray.200"
        bg="white"
        boxShadow="md"
      >
        <Text fontSize="md" fontWeight="bold" color="purple.700" mb={4}>
          Deleted Records From
        </Text>

        <Box display="flex" flexDirection="column" gap={4}>
          {departmentName && (
  <Box>
    <Text fontSize="sm" fontWeight="semibold" color="purple.600">
      Department
    </Text>

    <Text fontSize="sm" color="gray.700">
     {capitalizeWords(departmentName)}
    </Text>
  </Box>
)}
          {orderedEntries
            // .filter(([key]) => key !== 'id') // to remove id
            .filter(([key]) => !['id', 'org_id'].includes(key))
            .map(([key, value], index) => (
              <Box key={index}>
                <Text fontSize="sm" fontWeight="semibold" color="purple.600">
                  {key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase())}
                </Text>

                <Text fontSize="sm" color="gray.700">
                  {capitalizeWords(renderValue(data, key))}
                </Text>
              </Box>
            ))}
        </Box>
      </Box>
    );
  };

  const formatDate = (date) => {
    const d = new Date(date);
    return `${String(d.getDate()).padStart(2, '0')}-${String(
      d.getMonth() + 1,
    ).padStart(2, '0')}-${d.getFullYear()}`;
  };

  const getCompanyAuditLogs = async (sDate, eDate) => {
    setLoading(true);
    const start = sDate || startDate;
    const end = eDate || endDate;

    if (!start || !end) return;
    if (new Date(start) > new Date(end)) {
      toast.error('Start date cannot be after end date');
      return;
    }

    try {
      const isDemoMode = localStorage.getItem('demoMode') === 'true';
                  
      if (isDemoMode) {
        setCompanyAuditLogs(demoCompanyAuditLogs);
        return;
      }
      const response = await httpInjectorService.getCompanyAuditLogs({
        startDate: start,
        endDate: end,
      });

      if (response.status === 'success') {
        setCompanyAuditLogs(response.data);
      } else {
        setCompanyAuditLogs([]);
      }
    } catch (err) {
      setCompanyAuditLogs([]);
    } finally {
      setLoading(false);
    }
  };

  const getCurrentWeekRange = () => {
    const today = new Date();
    const end = new Date(today);
    const start = new Date(today);
    start.setDate(today.getDate() - 6);

    return {
      start: start.toISOString().split('T')[0],
      end: end.toISOString().split('T')[0],
    };
  };

  useEffect(() => {
    if (isActive) {
      const { start, end } = getCurrentWeekRange();
      setStartDate(start);
      setEndDate(end);
      getCompanyAuditLogs(start, end);
    }
  }, [isActive]);

  const exportToExcel = () => {
    if (companyAuditLogs.length === 0) return;

    const formattedData = companyAuditLogs.map((item) => ({
      ...item,

      changed_at: item.changed_at
      ? new Date(item.changed_at).toISOString().split('T')[0]
      : '',
      changed_fields: JSON.stringify(item.changed_fields),
      old_data: JSON.stringify(item.old_data),
      new_data: JSON.stringify(item.new_data),
    }));

    const ws = XLSX.utils.json_to_sheet(formattedData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');
    XLSX.writeFile(wb, 'company_audit.xlsx');
  };

  const columns = useMemo(
    () => [
      {
        Header: 'Sl No',
        accessor: 'serial',
        disableFilters: true,
        disableSortBy: false,
        Cell: ({ row }) => row.index + 1,
      },
      {
        Header: 'Employee ID',
        accessor: 'employee_id',
      },
      {
        Header: 'Changed Fields',
        accessor: 'changed_fields',
        disableFilters: true,
        Cell: (cellProps) => <ChangedFields {...cellProps} />,
      },
      {
        Header: 'Changed By',
        accessor: 'username',
      },

      {
        Header: 'Action',
        accessor: 'action',
        Cell: ({ value }) => {
          const map = {
            INSERT: 'Created',
            UPDATE: 'Updated',
            DELETE: 'Deleted',
          };

          return (
            <Text fontWeight="medium">{map[value] || value || 'Unknown'}</Text>
          );
        },
      },
      {
        Header: 'Changed At',
        accessor: 'changed_at',
        Cell: ({ value }) => formatDate(value),
      },
      {
        Header: 'Action',
        Cell: ({ row }) => (
          <Flex justifyContent="center">
            <IconButton
              icon={<ViewIcon />}
              size="sm"
              variant="ghost"
              colorScheme="purple"
              aria-label="View"
              onClick={() => {
                setSelectedLog(row.original);
                onOpen();
              }}
            />
          </Flex>
        ),
      },
    ],
    [],
  );

  return (
    <Box>
      {/* FILTERS */}
      <Flex gap={4} align="end" flexWrap="wrap">
        <Box>
          <Text fontSize="sm" marginTop={3} mb={1}>
            Start Date<span className="text-danger">*</span>
          </Text>
          <Input
            type="date"
            value={startDate}
            onChange={(e) => setStartDate(e.target.value)}
          />
        </Box>

        <Box>
          <Text fontSize="sm" marginTop={3} mb={1}>
            End Date<span className="text-danger">*</span>
          </Text>
          <Input
            type="date"
            value={endDate}
            onChange={(e) => setEndDate(e.target.value)}
          />
        </Box>

        <Button
          leftIcon={<MdFilterListAlt />}
          mb="1"
          size="sm"
          rounded={2}
          colorScheme="purple"
          onClick={() => getCompanyAuditLogs()}
        >
          Filter
        </Button>
      </Flex>

      {/* TABLE to store*/}
      {loading ? (
        <BulletList />
      ) : companyAuditLogs.length === 0 ? (
        <Empty className="mt-4" />
      ) : (
        <Box mt={4}>
          <Button
            leftIcon={<MdDownload />}
            size="sm"
            rounded={2}
            colorScheme="purple"
            float="right"
            onClick={exportToExcel}
          >
            Download
          </Button>

          <Box mt={6}>
            <TableContainer
              columns={columns}
              data={companyAuditLogs}
              isGlobalFilter={true}
              customPageSize={10}
              className="custom-header-css"
            />
          </Box>
        </Box>
      )}

      {/* MODAL (PROFILE STYLE MATCHED) */}
      <Modal isOpen={isOpen} onClose={onClose} size="6xl" isCentered>
        <ModalOverlay />
        <ModalContent borderRadius="xl">
          <ModalHeader bg="purple.600" color="white">
            Company Audit Details
          </ModalHeader>
          <ModalCloseButton color="white" />

          <ModalBody p={6} maxH="70vh" overflowY="auto">
            {selectedLog && (
              <>
                {/* HEADER */}
                <Box
                  mb={6}
                  p={5}
                  bg="purple.50"
                  borderRadius="xl"
                  border="1px solid"
                  borderColor="purple.100"
                >
                  <Text fontSize="xl" fontWeight="bold" color="purple.700">
                    {selectedLog.username} ({selectedLog.employee_id})
                  </Text>

                  {/* <Flex mt={2} gap={3} flexWrap="wrap"> */}
                    <Text fontSize="sm" color="gray.600" mt={1}>
                      Chnaged By: <b>{selectedLog.username}</b>
                    </Text>

                    <Flex mt={2} gap={3} flexWrap="wrap">
                    <Text fontSize="sm" color="gray.500">
                      {formatDate(selectedLog.changed_at)}
                    </Text>

                    <Badge colorScheme="green">{selectedLog.action}</Badge>
                    </Flex>
                  {/* </Flex> */}
                </Box>

                <Divider mb={6} />

                {/* DYNAMIC UI BASED ON ACTION */}
                {selectedLog.action === 'INSERT' && renderInsertUI(selectedLog)}

                {selectedLog.action === 'UPDATE' && renderDiffUI(selectedLog)}

                {selectedLog.action === 'DELETE' && renderDeleteUI(selectedLog)}
              </>
            )}
          </ModalBody>

          <ModalFooter>
            <Button
              rounded={2}
              size="sm"
              colorScheme="purple"
              onClick={onClose}
            >
              Close
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </Box>
  );
};

export default CompanyAudit;